import { isSignedIn } from '../functions';

export const isSignedGuard = (to, from, next) => {
  to.meta.auth
    ? isSignedIn()
      ? next()
      : next.redirect('/auth/sign-in')
    : next();
};
